import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not found. Sentry will not be initialized.");
    return;
  }

  Sentry.init({
    dsn,
    // Enable session replay for 10% of sessions
    replaysSessionSampleRate: 0.1,
    // Enable session replay for all error sessions
    replaysOnErrorSampleRate: 1.0,
    // Environment
    environment: import.meta.env.MODE || "development",
  });
};

export { Sentry };
